var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2049 29.8272C22.1595 29.7863 22.1207 29.7321 22.0911 29.668C22.0511 29.5812 22.0299 29.48 22.0299 29.3765C22.031 27.9586 22.4308 26.5992 23.1416 25.5966C23.7543 24.7323 24.5551 24.1939 25.4083 24.0609C24.4133 23.3117 23.7695 21.9121 23.7695 20.6175C23.7695 19.6767 24.1055 18.7743 24.7036 18.1091C25.3017 17.4438 26.1129 17.07 26.9587 17.07C27.0594 17.07 27.1596 17.0754 27.2589 17.0858C27.1117 16.8139 26.9099 16.5708 26.6616 16.3736L19.0828 10.3551C18.2569 9.69923 17.0924 9.68314 16.2487 10.3159L8.17096 16.3742C7.5869 16.8122 7.24316 17.4997 7.24316 18.2298V27.5077C7.24316 28.7888 8.28163 29.8272 9.56264 29.8272H12.317H14.4915V22.2889C14.4915 21.0079 15.53 19.9694 16.811 19.9694H17.9708C19.2518 19.9694 20.2902 21.0079 20.2902 22.2889V29.8272H22.2049Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8983 29.8974C26.3657 29.9377 24.8398 29.6812 23.4046 29.1418C23.3406 29.1133 23.2862 29.0669 23.248 29.0081C23.2097 28.9494 23.1895 28.8808 23.1895 28.8107C23.1905 27.8504 23.5725 26.9297 24.2515 26.2506C24.9306 25.5715 25.8513 25.1896 26.8117 25.1885H28.985C29.9453 25.1896 30.8661 25.5715 31.5451 26.2506C32.2242 26.9297 32.6062 27.8504 32.6072 28.8107C32.6072 28.8808 32.5869 28.9494 32.5487 29.0081C32.5105 29.0669 32.4561 29.1133 32.392 29.1418C30.9569 29.6812 29.4309 29.9377 27.8983 29.8974Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8265 23.8077C26.1679 23.8077 24.9287 22.0868 24.9287 20.5477C24.9287 19.7792 25.234 19.0421 25.7775 18.4987C26.3209 17.9552 27.0579 17.6499 27.8265 17.6499C28.5951 17.6499 29.3321 17.9552 29.8755 18.4987C30.419 19.0421 30.7243 19.7792 30.7243 20.5477C30.7243 22.0868 29.4851 23.8077 27.8265 23.8077Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85254 12.4316V17.0706",
    stroke: "#888888",
    strokeWidth: 2.31948,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_3183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5143,
    height: 20.2955,
    fill: "white",
    transform: "translate(7.24316 9.85205)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7aa643fea97133b08698b4860a58025a.svg";
export { ForwardRef as ReactComponent };